<template>
  <div>
    <FormKit
      type="hidden"
      :name="`components[${index}][component_type]`"
      :value="component.component_type"
    />

    <FormKit
      label="Titel"
      type="text"
      :name="`components[${index}][title]`"
      :value="component.title"
      @input="(value) => update('title', value)"
    />

    <FormKitCKEditor
      label="Content"
      :name="`components[${index}][content]`"
      :modelValue="component.content"
      @input="(value) => update('content', value)"
    />
  </div>
</template>

<script>
import mixin from "../mixins/component";

export default {
  name: "PageText",
  mixins: [mixin],
};
</script>